module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bloc bgc-white l-bloc"
  }, [_c('div', {
    staticClass: "container bloc-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-cae2879a"}!./src/app/components/bloc/bloc.html
// module id = 500
// module chunks = 1